import React, { useState, useEffect, useRef } from "react";
import { MdChevronRight } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/Header/Logo.svg";
import ButtonDKN from "../Button/ButtonDKN";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [isSolutionDropdownOpen, setIsSolutionDropdownOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const dropdownRef = useRef(null);
  const solutionDropdownRef = useRef(null);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsOpen(false);
    setIsDropdownOpen(false);
    setIsDropdownOpen1(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setIsDropdownOpen1(false);
      }
      if (solutionDropdownRef.current && !solutionDropdownRef.current.contains(event.target)) {
        setIsSolutionDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="bg-white w-full px-4 py-2.5">
      <div className="flex flex-wrap md:flex-nowrap justify-between items-center w-full">
        <div className="flex items-center laptop:pl-12 desktop:pl-44">
          <Link to="/" onClick={() => handleLinkClick("homed")}>
            <img
              src={Logo}
              className="mr-3 laptop:w-[140px] laptop:h-[33px] w-[152px] cursor-pointer"
              alt="BlueRise"
            />
          </Link>
        </div>
        {/* Desktop/Laptop Menu */}
        <div className="hidden laptop:flex items-center justify-center flex-1">
          <ul className="flex flex-row m-0 p-0 list-none items-center text-sm font-semibold space-x-8">
            <li className={`w-auto ${activeLink === "home" ? "active" : ""}`}>
              <Link
                to="/"
                className={`menu-item block py-2 px-3 text-[1rem] font-normal hover:text-[#5053ff] rounded whitespace-nowrap ${
                  activeLink === "home"
                    ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                    : "text-[#606060]"
                }`}
                onClick={() => handleLinkClick("home")}
              >
                Trang chủ
              </Link>
            </li>
            <li className={`w-auto ${activeLink === "gioi-thieu" ? "active" : ""}`}>
              <Link
                to="/gioi-thieu"
                className={`menu-item block py-2 px-3 text-[1rem] font-normal rounded hover:text-[#5053ff] whitespace-nowrap ${
                  activeLink === "gioi-thieu"
                    ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                    : "text-[#606060]"
                }`}
                onClick={() => handleLinkClick("gioi-thieu")}
              >
                Giới thiệu
              </Link>
            </li>
            <li className={`w-auto relative ${activeLink === "giai-phap" ? "active" : ""}`} ref={solutionDropdownRef}>
              <div
                onMouseEnter={() => setIsSolutionDropdownOpen(true)}
                onMouseLeave={() => setIsSolutionDropdownOpen(false)}
                className="relative"
              >
                <Link
                  to="/giai-phap"
                  className={`menu-item flex items-center gap-1 py-2 px-3 text-[1rem] font-normal rounded hover:text-[#5053ff] whitespace-nowrap ${
                    activeLink === "giai-phap"
                      ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                      : "text-[#606060]"
                  }`}
                  onClick={() => handleLinkClick("giai-phap")}
                >
                  Giải pháp
                  <FaChevronDown 
                    className={`text-[10px] transition-transform ${isSolutionDropdownOpen ? 'rotate-180' : ''}`} 
                  />
                </Link>
                {isSolutionDropdownOpen && (
                  <div 
                    className="absolute top-full left-0 pt-2 bg-transparent"
                  >
                    <div className="bg-white rounded-lg shadow-lg min-w-[200px] z-50 overflow-hidden border border-gray-200">
                      <button
                        className="w-full text-left px-4 py-3 text-[#606060] hover:bg-gray-100 hover:text-[#5053ff] transition-colors text-[16px] font-normal"
                        onClick={() => {
                          window.open("https://blueedu.vn/", "_blank");
                          setIsSolutionDropdownOpen(false);
                        }}
                      >
                        Tìm hiểu BlueEdu
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </li>
            <li className={`w-auto ${activeLink === "case-study" ? "active" : ""}`}>
              <Link
                to="/case-study"
                className={`menu-item block py-2 px-3 text-[1rem] font-normal rounded hover:text-[#5053ff] whitespace-nowrap ${
                  activeLink === "case-study"
                    ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                    : "text-[#606060]"
                }`}
                onClick={() => handleLinkClick("case-study")}
              >
                Case Study
              </Link>
            </li>
            <li className={`w-auto ${activeLink === "tintuc-sukien" ? "active" : ""}`}>
              <Link
                to="/tintuc-sukien"
                className={`menu-item block py-2 px-3 text-[1rem] font-normal rounded hover:text-[#5053ff] whitespace-nowrap ${
                  activeLink === "tintuc-sukien"
                    ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                    : "text-[#606060]"
                }`}
                onClick={() => handleLinkClick("tintuc-sukien")}
              >
                Tin tức và sự kiện
              </Link>
            </li>
            <li className={`w-auto ${activeLink === "tai-xuong" ? "active" : ""}`}>
              <Link
                to="/tai-xuong"
                className={`menu-item block py-2 px-3 text-[1rem] font-normal rounded hover:text-[#5053ff] whitespace-nowrap ${
                  activeLink === "tai-xuong"
                    ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                    : "text-[#606060]"
                }`}
                onClick={() => handleLinkClick("tai-xuong")}
              >
                Tải xuống
              </Link>
            </li>
            <li className={`w-auto ${activeLink === "lien-he" ? "active" : ""}`}>
              <Link
                to="/lien-he"
                className={`menu-item block py-2 px-3 text-[1rem] font-normal rounded hover:text-[#5053ff] whitespace-nowrap ${
                  activeLink === "lien-he"
                    ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                    : "text-[#606060]"
                }`}
                onClick={() => handleLinkClick("lien-he")}
              >
                Liên hệ
              </Link>
            </li>
          </ul>
        </div>
        {/* Desktop/Laptop Button */}
        <div className="hidden laptop:flex items-center laptop:pr-12 desktop:pr-44">
          <ButtonDKN
            txt="Đăng ký tư vấn"
            className="text-white hover:bg-[#032478] font-medium rounded-lg text-sm px-4 py-2 text-center laptop:w-56 laptop:rounded-[30px] h-11"
            cl="hover:bg-[#032478] laptop:rounded-[30px] bg-trangchu hover:bg-pa"
          />
        </div>
        {/* Mobile/Tablet Hamburger */}
        <div className="flex items-center laptop:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            type="button"
            className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg"
            aria-controls="mobile-menu"
            aria-expanded={isOpen ? "true" : "false"}
          >
            <span className="sr-only">Open main menu</span>
            {isOpen ? (
              <IoMdClose className="w-[36px] h-[36px]" />
            ) : (
              <svg
                className="w-[36px] h-[36px]"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M3 5h14a1 1 0 010 2H3a1 1 0 110-2zm0 4h14a1 1 0 010 2H3a1 1 0 110-2zm0 4h14a1 1 0 010 2H3a1 1 0 110-2z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        </div>
      </div>
      {/* Mobile/Tablet Menu */}
      <div
        className={`w-full laptop:hidden ${
          isOpen ? "block" : "hidden"
        }`}
        id="mobile-menu"
      >
        <ul
          className="flex flex-col m-0 p-0 mt-4 list-none"
          ref={dropdownRef}
        >
          <li
            className={`flex items-center justify-between w-full ${
              activeLink === "home" ? "active" : ""
            }`}
          >
            <Link
              to="/"
              className={`menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal hover:text-[#5053ff] rounded md:p-0 whitespace-nowrap ${
                activeLink === "home"
                  ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                  : "text-[#606060]"
              }`}
              onClick={() => handleLinkClick("home")}
            >
              Trang chủ
            </Link>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>

          <li
            className={`flex items-center justify-between w-full ${
              activeLink === "gioi-thieu" ? "active" : ""
            }`}
          >
            <Link
              to="/gioi-thieu"
              className={`menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal rounded hover:text-[#5053ff] md:p-0 whitespace-nowrap ${
                activeLink === "gioi-thieu"
                  ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                  : "text-[#606060]"
              }`}
              onClick={() => handleLinkClick("gioi-thieu")}
            >
              Giới thiệu
            </Link>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>

          <li
            className={`flex items-center justify-between w-full ${
              activeLink === "giai-phap" ? "active" : ""
            }`}
          >
            <Link
              to="/giai-phap"
              className={`menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal rounded hover:text-[#5053ff] md:p-0 whitespace-nowrap ${
                activeLink === "giai-phap"
                  ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                  : "text-[#606060]"
              }`}
              onClick={() => handleLinkClick("giai-phap")}
            >
              Giải pháp
            </Link>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>

          <li className="flex items-center justify-between w-full">
            <button
              className="menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal rounded hover:text-[#5053ff] md:p-0 whitespace-nowrap text-[#606060]"
              onClick={() => {
                window.open("https://blueedu.vn/", "_blank");
                setIsOpen(false);
              }}
            >
              Tìm hiểu BlueEdu
            </button>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>

          <li
            className={`flex items-center justify-between w-full ${
              activeLink === "case-study" ? "active" : ""
            }`}
          >
            <Link
              to="/case-study"
              className={`menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal rounded hover:text-[#5053ff] md:p-0 whitespace-nowrap ${
                activeLink === "case-study"
                  ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                  : "text-[#606060]"
              }`}
              onClick={() => handleLinkClick("case-study")}
            >
              Case Study
            </Link>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>

          <li
            className={`flex items-center justify-between w-full ${
              activeLink === "tintuc-sukien" ? "active" : ""
            }`}
          >
            <Link
              to="/tintuc-sukien"
              className={`menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal rounded hover:text-[#5053ff] md:p-0 whitespace-nowrap ${
                activeLink === "tintuc-sukien"
                  ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                  : "text-[#606060]"
              }`}
              onClick={() => handleLinkClick("tintuc-sukien")}
            >
              Tin tức và sự kiện
            </Link>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>
          <li
            className={`flex items-center justify-between w-full ${
              activeLink === "tai-xuong" ? "active" : ""
            }`}
          >
            <Link
              to="/tai-xuong"
              className={`menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal rounded hover:text-[#5053ff] md:p-0 whitespace-nowrap ${
                activeLink === "tai-xuong"
                  ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                  : "text-[#606060]"
              }`}
              onClick={() => handleLinkClick("tai-xuong")}
            >
              Tải xuống
            </Link>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>

          <li
            className={`flex items-center justify-between w-full ${
              activeLink === "lien-he" ? "active" : ""
            }`}
          >
            <Link
              to="/lien-he"
              className={`menu-item block py-2 pr-4 pl-3 text-[1rem] font-normal rounded hover:text-[#5053ff] md:p-0 whitespace-nowrap ${
                activeLink === "lien-he"
                  ? "border-b-2 border-[#053CC8] text-[#053CC8]"
                  : "text-[#606060]"
              }`}
              onClick={() => handleLinkClick("lien-he")}
            >
              Liên hệ
            </Link>
            <MdChevronRight size={30} className="block lg:hidden md:hidden" />
          </li>

          <li className="py-3 block md:hidden">
            <ButtonDKN
              txt="Đăng ký tư vấn"
              className="text-white font-medium bg-trangchu  rounded-[30px] text-sm px-4 py-2 text-center mr-3 md:mr-0 lg:w-56 lg:rounded-[30px] h-11"
              cl="hover:bg-[#032478] rounded-[30px] "
            />
          </li>
        </ul>
      </div>
      <style jsx>{`
        .menu-item {
          width: auto;
          height: 56px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 16px 8px 16px 8px;
        }
        .active {
          background-color: #e6ecfa;
        }
        @media (min-width: 1280px) {
          .menu-item {
            height: auto;
            padding: 8px 12px;
          }
        }
      `}</style>
    </div>
  );
}
